module.exports = __webpack_public_path__ + "img/hint.ca59f81d.svg";